import { shallowRef, computed } from 'vue'
import { get, getDomain } from '../../../utils/index'
import { Loading } from 'element-ui'

export function usePdfImg({ attach, pageNo, url = 'rest/ezcomp/pdf/preview', dpi = '144' }) {
  const imgList = shallowRef([])
  const transfromImg = async () => {
    imgList.value = []
    let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
    const [res] = await get(url, { dpi, url: getDomain(attach.value.url) }, { errorTip: '' })
    loadingInstance.close()
    if (res) {
      imgList.value = res.data ?? []
    }
    return imgList.value
  }

  const imgAttach = computed(() => {
    if (!imgList.value.length) {
      return {}
    } else {
      return { url: imgList.value[pageNo.value - 1] }
    }
  })

  return {
    imgAttach,
    transfromImg,
  }
}
